import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";




const Testimonials = [
    {
        name: 'Robert, WBAB',
        title: 'Client',
        descriptoion: '“Amazing looking theme and instantly turns your application into a great looking one. Really shows that professionals built this theme up. Very happy with the way the theme looks.”',
    },
    {
        name: 'Justin, Goin.org',
        title: 'Client',
        descriptoion: '“The platform not only meets but exceeds user expectations, providing a reliable and efficient service akin to industry leaders like Uber.”',
    },
    {
        name: 'Matt, Journeyfront',
        title: 'Client',
        descriptoion: '“This project allowed me to leverage my expertise in both backend and frontend technologies, delivering a high-quality platform that empowers organizations to make data-driven decisions about their workforce.”',
    },
    {
        name: 'David, Limelite',
        title: 'Client',
        descriptoion: '“This project allowed me to leverage my full-stack development skills to build an integrated solution that addressed both functional and performance needs, providing users with a seamless and intuitive experience.”',
    },
    {
        name: 'Alysa, Paloma',
        title: 'Client',
        descriptoion: '“The app handles talent submissions, profiles, and digital portfolios, while also offering robust management features for both talent agents and clients.”',
    },
    {
        name: 'Rob, Galaxy Creations',
        title: 'Client',
        descriptoion: '“The successful deployment of this system significantly enhanced Galaxy Creations\' service offerings, providing clients with a powerful tool to establish a dynamic online presence.”',
    },
    {
        name: 'Bruce, Fundify',
        title: 'Client',
        descriptoion: '“The successful implementation of these features contributed to Fundify\'s mission of simplifying startup investing, providing users with a platform that is both intuitive and powerful.”',
    },
    {
        name: 'Stuart, Rainbird Sprinklers',
        title: 'Client',
        descriptoion: '“The result is a powerful, user-friendly platform that simplifies sprinkler system selection for Rainbird’s customers.”',
    },
];


const Testimonial = () => {

    var settings = {
        dots: false,
        arrows: false,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (

        <section className="tp-testimonial-section section-padding">
            <div className="container">
                <div className="tp-section-title">
                    <span>Testimonials</span>
                    <h2>What My clients say.</h2>
                </div>

                <div className="tp-testimonial-wrap">
                    <Slider {...settings}>
                        {Testimonials.map((tstml, tsm) => (
                            <div className="tp-testimonial-item" key={tsm}>
                                <div className="tp-testimonial-text">
                                    <p>{tstml.descriptoion}</p>
                                    <span>{tstml.name}</span>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
            <div className="visible-rotate-text">
                <h1>Review</h1>
            </div>
        </section>
    )
}

export default Testimonial;